import { apiClient } from "@/lib/api-client";

export type UnsurMengujiTaData = Record<string, any>;

export type UnsurMengujiTaResponse = {
  datas: UnsurMengujiTaData;
  message: string;
};

export const fetchUnsurMengujiTa = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<UnsurMengujiTaData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<UnsurMengujiTaResponse>(
    `${baseUrl}/api/v1/unsur-menguji-ta/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return resData.datas;
};
